import React from "react";

export default function LastUsedBadge() {
  return (
    <span className="inline-flex shrink-0 whitespace-nowrap rounded-v7-control border border-v7-ink/15 bg-v7-paper px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-v7-ink-soft dark:border-v7-ink/15 dark:bg-v7-paper dark:text-v7-ink-soft">
      Last used
    </span>
  );
}
